import { render } from "./labelprinter.vue?vue&type=template&id=11362aea"
import script from "./labelprinter.vue?vue&type=script&lang=js"
export * from "./labelprinter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__